<template>
  <footer class="s-footer-main">
    <SAppContainer class="s-footer-main__top">
      <div class="s-footer-main__brand">
        <img
          :alt="tr('main_site.layout.header_logo_alt')"
          class="s-footer-main__logo"
          :src="logoUrl"
        />
        <p class="s-footer-main__description">
          {{ tr("main_site.layout.footer_description") }}
        </p>
        <SFooterNewsletter class="s-footer-main__newsletter" />
      </div>

      <SFooterMenu class="s-footer-main__menu" :link-component="linkComponent">
        <template #contact>
          <SFooterContact :website-type="websiteType" />
        </template>
      </SFooterMenu>
    </SAppContainer>

    <SAppContainer>
      <PDivider class="s-footer-main__divider" />
    </SAppContainer>

    <SFooterBottom :link-component="linkComponent" />
  </footer>
</template>

<script setup lang="ts">
import type { Component } from "vue";

import { useI18nMainSiteLayout } from "@solvari/translations";
import { getEnv } from "@solvari/utils";

import PDivider from "@/atoms/PDivider.vue";
import SAppContainer from "@/atoms/SAppContainer.vue";
import SFooterBottom from "@/organisms/footer/SFooterBottom.vue";
import SFooterContact from "@/organisms/footer/SFooterContact.vue";
import SFooterMenu from "@/organisms/footer/SFooterMenu.vue";
import SFooterNewsletter from "@/organisms/footer/SFooterNewsletter.vue";

defineProps<{
  linkComponent?: Component;
  websiteType?: "mainSite" | "mySolvari";
}>();

const { tr } = useI18nMainSiteLayout();

const logoUrl = `${getEnv().network.static}/shared/svg/solvari-wit.svg`;
</script>

<style lang="postcss">
.s-footer-main {
  @apply bg-primary-700;
  container-type: inline-size;

  &__top {
    @apply flex flex-col pt-6 gap-2;
  }

  &__brand {
    @apply flex min-w-56 flex-col self-stretch gap-2;
  }

  &__logo {
    @apply mt-1.5 h-6 w-fit;
  }

  &__description {
    @apply mb-4 mt-2 text-base font-medium text-white;
  }

  &__divider {
    @apply mb-0 before:!border-slate-500;
  }

  &__newsletter {
    @apply mb-3 max-w-2xl;
  }

  @screen 1000 {
    &__top {
      @apply flex-row items-start pt-10 gap-8;
    }

    &__brand {
      @apply max-w-64 flex-none;
    }

    &__menu {
      @apply grow;
    }
  }

  @screen 1300 {
    &__brand {
      @apply flex-none;
    }
  }
}
</style>
